import { Category } from '@/types/dmaker/info.type'
import JSONParse from '@/utils/JSONParse'
import { CookedCategory } from '@/types/dmaker/category.type'
import { GameDifficulty } from '@/types/dmaker/game-config.type'
import { isPresetOptionCategory } from '@/store/creative/common/category'

export function getPresetOptionValue(cat: Category): string {
  let value = cat.name
  if (
    cat.properties &&
    JSONParse(cat.properties) &&
    JSONParse(cat.properties).preset_option
  ) {
    value = JSONParse(cat.properties).preset_option
  }
  return value
}

// 判断是否是 preset 的 prefix，现在都是通过 prefix 是否含有冒号来判断的
export function isPresetPrefix(prefix: string): boolean {
  return prefix.includes(':')
}

export function syncCategoryToPresetConfig(
  cat: CookedCategory,
  presetConfig: GameDifficulty,
): void {
  if (!isPresetOptionCategory(cat)) {
    console.log('当前分类非 preset option 分类，不需要同步修改到 presetConfig')
    return
  }
  if (
    cat.properties &&
    cat.properties.preset &&
    presetConfig &&
    presetConfig[cat.properties.preset]
  ) {
    const config = presetConfig[cat.properties.preset]
    if (
      config.options &&
      config.options_en &&
      config.options.length &&
      config.options_en.length
    ) {
      config.options.forEach((opt) => {
        if (opt.value === cat.prefix) {
          opt.label = cat.name
          opt.text = cat.name
        }
      })
      config.options_en.forEach((opt) => {
        if (opt.value === cat.prefix) {
          opt.label = cat.name_en
          opt.text = cat.name_en
        }
      })
    } else {
      console.warn('presetConfig 中当前预设的 options 为空，无法同步修改')
    }
  } else {
    console.warn('当前分类的 preset 属性不存在于 presetConfig 中，无法同步修改')
  }
}
